import { createSelector } from 'reselect';

import * as entitiesSelectors from './entities';

export const getPolicies = entitiesSelectors.createEntitiesForViewSelector(
  'ptoPolicies',
  'ptoPolicy'
);

export const getIsFetching = (state, { id }) =>
  state.getIn(['ptoPolicy', 'isFetching']).has(id);
export const getIsFetchingIds = state =>
  state.getIn(['ptoPolicy', 'isFetching']);

export const getCurrentPolicyId = (state, props = {}) => props.policyId;
export const getNewPolicyId = state =>
  state.getIn(['ptoPolicy', 'newPolicy', 'id']);

export const getCurrentPolicy = createSelector(
  getPolicies,
  getCurrentPolicyId,
  getNewPolicyId,
  (policies, currentId, newId) => {
    if (!currentId && !newId) {
      return null;
    }

    return currentId
      ? policies.get(currentId.toString())
      : policies.get(newId.toString());
  }
);

export const getBailoutFetchPolicy = createSelector(
  getCurrentPolicyId,
  getIsFetchingIds,
  getPolicies,
  (id, isFetchingIds, policies) =>
    isFetchingIds.has(`policy${id}`) || policies.has(id.toString())
);
